import React, { useEffect, useState } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { TabNav } from 'src/components/TabNav';

import s from './Orientation.module.scss';
import {
  EOrientationParam,
  EOrientationView,
  TOrientationParam,
  TOrientationProps,
} from './Orientation.types';
import { OrientationAdvanced } from './OrientationAdvanced';
import { OrientationBasic } from './OrientationBasic';

export const Orientation: React.FC<TOrientationProps> = ({
  className,
  azimuthValuesForCustomPV,
  setAzimuthValuesForCustomPV,
  theme,
}) => {
  const { t } = useTranslation();

  const [view, setView] = useState<EOrientationView>(EOrientationView.BASIC);
  const [orientationParam, setOrientationParam] = useState<TOrientationParam>(
    azimuthValuesForCustomPV || {
      [EOrientationParam.AZIMUTH]: 0,
      [EOrientationParam.TILT]: 0,
    },
  );

  useEffect(() => {
    setAzimuthValuesForCustomPV?.(orientationParam);
  }, [orientationParam, setAzimuthValuesForCustomPV]);

  return (
    <div className={classnames(s.orientation, className)}>
      <TabNav
        className={s.tabNav}
        nav={[
          {
            label: t('navigation.BASIC_SETTINGS'),
            onClick() {
              setView(EOrientationView.BASIC);
            },
            isActive: view === EOrientationView.BASIC,
          },
          {
            label: t('navigation.ADVANCED_SETTINGS'),
            onClick() {
              setView(EOrientationView.ADVANCED);
            },
            isActive: view === EOrientationView.ADVANCED,
          },
        ]}
        theme={theme === 'light' ? '1' : '2'}
      />
      {view === EOrientationView.BASIC && (
        <OrientationBasic
          theme={theme}
          orientationParam={orientationParam}
          setOrientationParam={setOrientationParam}
          isWhiteIcons
        />
      )}
      {view === EOrientationView.ADVANCED && (
        <OrientationAdvanced
          theme={theme}
          orientationParam={orientationParam}
          setOrientationParam={setOrientationParam}
        />
      )}
    </div>
  );
};
